import { defineSlotRecipe } from '@chakra-ui/react';
import { alertAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: alertAnatomy.keys(),
  defaultVariants: {
    size: 'lg',
  },
  variants: {
    size: {
      lg: {},
    },
    variant: {
      subtle: {
        root: {
          color: 'inherit',
        },
      },
    },
  },
  base: {
    root: {
      borderRadius: '0',
    },
    indicator: {
      color: 'colorPalette.fg',
      mr: 3,
    },
  },
});
